import {Typography} from '@mui/material';

export interface Props {
  title: string;
  count?: number;
}

export const WorkforceProfileAnalysisInputSubsectionTitle = ({title, count}: Props) => (
  <Typography variant='h3' sx={{fontWeight: 600, mb: 1.5}}>
    {title}
    {count != null ? ` (${count})` : ''}
  </Typography>
);
